'use strict';

$(document).ready(function() {
    function featuredCatSlider() {
        let $carouselWrapper = $('.featured-cat-wrapper');
        let _carouselOptions = {
            infinite: false,
            slidesToShow: 2.5,
            slidesToScroll: 2
        }
        if((window.matchMedia('(max-width: 544px)').matches) && $carouselWrapper.length > 0) {
            !$carouselWrapper.hasClass('slick-initialized') ? $carouselWrapper.slick(_carouselOptions): "";
        } else {
            $carouselWrapper.hasClass('slick-initialized') ? $carouselWrapper.slick('unslick') : '';
        }
    }

    featuredCatSlider();
    
    $(window).on('resize orientationchange', function() {
        featuredCatSlider();
    });
});